import { AddLink } from './addLink';
import { AddToMenu } from './addToMenu';

export const MenuEditorService = angular
    .module('app.pages.editstore.menuEditor.menuEditorService', [
        'ngMaterial',
        AddLink,
        AddToMenu
    ]).service('menuEditorService', ($mdDialog) => {
        function openAddToMenuDialog(blacklistTypes, parent) {
            return $mdDialog.show({
                parent: angular.element(parent),
                clickOutsideToClose: true,
                controller: ['$scope', '$mdDialog', function DialogController(_$scope, _$mdDialog) {
                    _$scope.hide = (itemToAdd) => { _$mdDialog.hide(itemToAdd); };
                    _$scope.cancel = () => { _$mdDialog.cancel(); };
                }],
                autoWrap: false,
                template: `
                    <md-dialog class="menu-editor-dialog">
                        <menu-editor-add-to-menu
                            ${blacklistTypes ? `blacklist-types="${blacklistTypes}"` : ''}
                            on-item-selected="hide">
                        </menu-editor-add-to-menu>
                    </md-dialog>
                `
            }).then(newItem => newItem);
        }

        function openEditLinkDialog(prefillData, parent) {
            return $mdDialog.show({
                parent: angular.element(parent),
                clickOutsideToClose: true,
                locals: { prefillData },
                controller: ['$scope', '$mdDialog', 'prefillData',
                    function EditLinkDialogController(_$scope, _$mdDialog, _prefillData) {
                        _$scope.prefillData = _prefillData;
                        _$scope.hide = (editedItem) => { _$mdDialog.hide(editedItem); };
                        _$scope.cancel = () => { _$mdDialog.cancel(); };
                    }
                ],
                template: `
                    <menu-editor-add-link
                        prefill-link-data="prefillData"
                        on-cancel-click="cancel()"
                        on-link-saved="hide(item)">
                    </menu-editor-add-link>
                `
            }).then(editedItem => editedItem);
        }

        return {
            openAddToMenuDialog,
            openEditLinkDialog
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/menuEditor/menuEditor.service.js